<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-5">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.titulo') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <form class="w-100" @submit.prevent="login">
                            <div class="form-group">
                                <label for="email">{{ $t('formularios.email') }}</label>
                                <input type="text" name="email" id="email" v-model="login_data.email"/>
                            </div>
                            <div class="form-group">
                                <label for="password">{{ $t('formularios.password') }}</label>
                                <input type="password" name="password" id="password" v-model="login_data.password"/>
                                <span class="error" v-if="mensaje">{{ mensaje }}</span>
                            </div>
                            
                            <div class="row justify-content-md-between">
                                <div class="col-12 col-lg-6">
                                    <button type="submit" class="button" name="button">{{ $t('login.enviar') }}</button>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <p class="forgot recupera_texto">
                                        <router-link
                                            :to="{ name: 'forgot-password' }"
                                            class="text-underline text-bold"
                                        >
                                            <small>{{ $t('login.recuperar') }}</small>
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script>
    import LoginContent from '@/components/frontend/components/LoginContent';

    export default {
        data() {
            return {
                login_data: {},
                mensaje: null
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            login() {
                this.login_data.filters = {
                    tid : this.configuracion.hash_teatro
                }
                this.$store.dispatch(this.config.getVuexAlias('login'), this.login_data).then(res => {
                    if(res.data.user.tipo != 'user') {
                        this.$router.push({ name: 'back.events.index' });
                    } else {
                        this.$router.push({ name: 'perfil' });
                    }
                }).catch(error => {
                    console.log(error);
                    this.mensaje = 'Email o contraseña incorrecta';                    
                });
            }
        },
        components: {
            LoginContent
        }
    }
</script>

<style scoped>
    .recupera_texto {
        text-align: right;
    }

    @media (max-width: 768px)  {
        .recupera_texto {
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 1em;
        }
    }
</style>
